import { render } from "./camera.vue?vue&type=template&id=7d48d6e2&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"

import "./camera.vue?vue&type=style&index=0&id=7d48d6e2&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d48d6e2"]])

export default __exports__